// Libraries
import React from 'react';
import { BrowserRouter, Route, Switch, NavLink } from 'react-router-dom';
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import CookieConsent from "react-cookie-consent";
import Loadable from 'react-loadable';

// Utilities
import rootReducer from '../../redux/reducers'
import withTracker from '../../withTracker'

// Components
import Header from '../Header/Header'
import Footer from '../Footer/Footer'

import './App.css'

const store = createStore(rootReducer)

// temporary loader
const Loader = () => <div>Loading...</div>

const Home = Loadable({
    loader: () => import('../Home/Home'),
    loading() {
        return <Loader />
    }
});
const Landscape = Loadable({
    loader: () => import('../Landscape/Landscape'),
    loading() {
        return <Loader />
    }
});
const Imprint = Loadable({
    loader: () => import('../Imprint/Imprint'),
    loading() {
        return <Loader />
    }
});

const Privacy = Loadable({
    loader: () => import('../Privacy/Privacy'),
    loading() {
        return <Loader />
    }
});

const Statistics = Loadable({
    loader: () => import('../Statistics/Statistics'),
    loading() {
        return <Loader />
    }
});

const Faq = Loadable({
    loader: () => import('../Faq/Faq'),
    loading() {
        return <Loader />
    }
});

const Glossary = Loadable({
    loader: () => import('../Glossary/Glossary'),
    loading() {
        return <Loader />
    }
});

const Articles = Loadable({
    loader: () => import('../Articles/Articles'),
    loading() {
        return <Loader />
    }
});

class App extends React.Component {

    componentDidMount() {
        setTimeout(() => {
            console.log("Preloading all loadables.");

            Home.preload();
            Landscape.preload();
            Imprint.preload();
            Privacy.preload();
            Statistics.preload();
            Faq.preload();
            Glossary.preload();
            Articles.preload();
        }, 2000)
    }

    render() {
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <div className="rootContainer">
                        <Header />
                        <Switch>
                            <Route exact path='/' component={withTracker(Home)} />
                            <Route exact path='/landscape/:categoryId/:componentId' component={withTracker(Landscape)} />
                            <Route exact path='/landscape/:categoryId' component={withTracker(Landscape)} />
                            <Route exact path='/landscape' component={withTracker(Landscape)} />
                            <Route exact path='/statistics' component={withTracker(Statistics)} />
                            <Route exact path='/blog' component={withTracker(Articles)} />
                            <Route path='/faq' component={withTracker(Faq)} />
                            <Route path='/glossary' component={withTracker(Glossary)} />
                            <Route path='/imprint' component={withTracker(Imprint)} />
                            <Route path='/privacy' component={withTracker(Privacy)} />
                        </Switch>
                        <Footer />
                        <CookieConsent>
                            This website uses cookies to enhance the user experience. By continuing to use the site, you agree to the use of cookies.
                            <NavLink to="/privacy"> More information...</NavLink>
                        </CookieConsent>
                    </div>
                </BrowserRouter>
            </Provider>
        )
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App/App.js